import React from "react";
import { css } from "react-emotion";

const svgStyle = css``;

const svgContainer = css`
  display: inline-block;
  vertical-align: middle;
  width: 30px;
  border-radius: 50%;
  text-align: center;
  transition: transform 250ms ease;
  display: inline-block;
  vertical-align: middle;
`;

const iconPaths = {
  checkmark: (
    <img src="https://mobile360-assets.s3.us-east-2.amazonaws.com/checkout/check-mark.svg" />
  ),
  one: (
    <img src="https://mobile360-assets.s3.us-east-2.amazonaws.com/checkout/one.svg" />
  ),
  two: (
    <img src="https://mobile360-assets.s3.us-east-2.amazonaws.com/checkout/two.svg" />
  ),
  three: (
    <img src="https://mobile360-assets.s3.us-east-2.amazonaws.com/checkout/three.svg" />
  ),
  four: (
    <img src="https://mobile360-assets.s3.us-east-2.amazonaws.com/checkout/four.svg" />
  ),
};

function CheckoutIcon({ iconName, ...props }) {
  return <div className={svgContainer}>{iconPaths[iconName]}</div>;
}

export default CheckoutIcon;
